/*
  Chefs Evolution – pagina de produs (blocul ce-produs):
  - livrarea: primul interval deschis din programul din admin, cu timpul rămas până la ora de oprire;
  - cadoul: pragurile din admin și cât mai e până la următorul (după coșul actual);
  - „Merge bine cu”: recomandările Shopify (complementare, apoi asemănătoare), cu „+” (din ce-acasa.js);
  - scurtăturile: deschid tabul descrierii și duc la Ingrediente / Alergeni / Valori nutriționale.
  Coșul se recitește singur după orice adăugare sau modificare (formularul temei, „+”, coșul lateral).
*/
(function () {
  'use strict';
  if (window.__ceProdus) return;
  window.__ceProdus = true;

  var RAD = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var API = 'https://clienti.mancaregatita.ro';
  var FUS = 'Europe/Bucharest';
  var formatBani = null;
  var cutie = null;
  var produsId = null;
  var cos = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function json(url) { return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
  function bani(centi) {
    var v = ((Number(centi) || 0) / 100).toFixed(2);
    var p = v.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (formatBani || '{' + '{amount}} lei').replace(/\{\{\s*\w+\s*\}\}/, p.join('.')).replace(/<[^>]*>/g, '');
  }
  function imagineUrl(src, w) {
    if (!src) return '';
    var u = typeof src === 'string' ? src : (src.src || src.url || '');
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function incarcaCos() {
    return json(RAD + 'cart.js').then(function (c) { cos = c; return c; }).catch(function () { return cos; });
  }

  // ---------- livrarea ----------
  var livrare = { el: null, date: null, ceas: null };
  var luni = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
  function numeZi(z, index) {
    if (index === 0) return 'azi';
    if (index === 1) return 'mâine';
    var d = String(z.data).split('-');
    return (z.numeZi ? z.numeZi.toLowerCase() + ', ' : '') + Number(d[2]) + ' ' + luni[Number(d[1]) - 1];
  }
  function cat(ms) {
    var min = Math.max(1, Math.ceil(ms / 60000));
    var h = Math.floor(min / 60), m = min % 60;
    if (!h) return m + ' min';
    return h + ' h' + (m ? ' ' + m + ' min' : '');
  }
  function primulInterval(d) {
    var zile = (d && d.zile) || [];
    for (var i = 0; i < zile.length; i++) {
      var x = (zile[i].intervale || []).filter(function (y) { return y.deschis; })[0];
      if (x) return { zi: zile[i], index: i, interval: x };
    }
    return null;
  }
  function deseneazaLivrare() {
    var el = livrare.el, g = livrare.date;
    if (!el) return;
    if (!g) { el.hidden = true; return; }
    var ramas = new Date(g.interval.oprireLa).getTime() - Date.now();
    if (ramas <= 0) { el.hidden = true; clearInterval(livrare.ceas); incarcaLivrare(); return; }
    var zi = numeZi(g.zi, g.index);
    var ora = 'între ' + esc(g.interval.start) + ' și ' + esc(g.interval.sfarsit);
    var text;
    if (ramas <= 24 * 3600e3) {
      text = 'Comandă în <b>' + cat(ramas) + '</b> și poate ajunge <b>' + esc(zi) + '</b> în București, ' + ora;
    } else {
      text = 'Următoarea livrare: <b>' + esc(zi) + '</b>, ' + ora;
    }
    el.innerHTML = '<span class="ce-produs__punct" aria-hidden="true"></span><span>' + text + '</span>';
    el.classList.toggle('is-azi', g.index === 0);
    el.hidden = false;
  }
  function incarcaLivrare() {
    return json(API + '/api/disponibilitate?produse=' + encodeURIComponent(produsId)).then(function (d) {
      livrare.date = primulInterval(d);
      deseneazaLivrare();
      clearInterval(livrare.ceas);
      if (livrare.date) livrare.ceas = setInterval(deseneazaLivrare, 30000);
    }).catch(function () { if (livrare.el) livrare.el.hidden = true; });
  }

  // ---------- cadoul ----------
  var cadou = null;
  function incarcaCadou() {
    if (cadou) return Promise.resolve(cadou);
    return json(API + '/api/cadou').then(function (c) {
      cadou = c && c.activ && Array.isArray(c.praguri) ? c.praguri.filter(function (p) { return p.produse && p.produse.length; }).sort(function (a, b) { return a.prag - b.prag; }) : [];
      return cadou;
    }).catch(function () { cadou = []; return cadou; });
  }
  var ICON_CADOU = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3.5-5.5-3.5-5.5-1S10 7 12 7zm0 0c1.5-3.5 5.5-3.5 5.5-1S14 7 12 7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  function deseneazaCadou() {
    var el = cutie.querySelector('[data-ce-cadou]');
    if (!el) return;
    if (!cadou || !cadou.length || !cos) { el.hidden = true; return; }
    var sub = cos.items.reduce(function (s, it) { return it.properties && it.properties._cadou ? s : s + it.original_line_price; }, 0);
    var praguri = cadou.map(function (p) { return { centi: Math.round(p.prag * 100), p: p }; });
    var max = praguri[praguri.length - 1].centi;
    var urm = praguri.filter(function (x) { return sub < x.centi; })[0];
    var atinse = praguri.filter(function (x) { return sub >= x.centi; });
    function ce(p) { return p.produse.length > 1 ? 'un cadou la alegere' : '<b>' + esc(p.produse[0].titlu) + '</b> cadou'; }
    var mesaj, nota;
    if (urm) {
      mesaj = 'Mai adaugă <strong>' + esc(bani(urm.centi - sub)) + '</strong> și primești ' + ce(urm.p) + '.';
      nota = atinse.length ? 'Ai deja un cadou de ales în coș.' : 'Cadoul îl alegi în coș, când ajungi la prag.';
    } else {
      mesaj = 'Ai ajuns la <strong>' + esc(bani(atinse[atinse.length - 1].centi)) + '</strong>: ai cadou.';
      nota = 'Cadoul îl alegi în coș.';
    }
    var h = '<p class="ce-cadou__mesaj">' + ICON_CADOU + '<span>' + mesaj + '</span></p>';
    h += '<div class="ce-cadou__bara"><div class="ce-cadou__fir"><i style="width:' + Math.min(100, sub / max * 100).toFixed(1) + '%"></i></div>';
    praguri.forEach(function (x, i) {
      var p = x.p, prim = p.produse[0];
      var ultim = i === praguri.length - 1;
      var nume = p.produse.length > 1 ? 'La alegere' : prim.titlu;
      h += '<div class="ce-cadou__prag' + (sub >= x.centi ? ' is-atins' : '') + (ultim ? ' is-ultim' : '') + '" style="left:' + (x.centi / max * 100).toFixed(2) + '%">' +
        '<span class="ce-cadou__cerc">' + (prim.imagine ? '<img src="' + esc(imagineUrl(prim.imagine, 80)) + '" alt="" loading="lazy" width="34" height="34">' : '') + '</span>' +
        '<span class="ce-cadou__eti"><b>' + esc(bani(x.centi).replace(/[.,]00(?!\d)/, '')) + '</b><em>' + esc(nume) + '</em></span></div>';
    });
    h += '</div><small class="ce-cadou__nota">' + nota + '</small>';
    el.innerHTML = h;
    el.hidden = false;
  }

  // ---------- „Merge bine cu” ----------
  function nrOptiuni(p) { return Array.isArray(p.options) ? p.options.length : 1; }
  function rand(p) {
    var variante = p.variants || [];
    var simplu = variante.length <= 1;
    var mod = simplu ? 'direct' : (nrOptiuni(p) > 1 ? 'pagina' : 'marime');
    var prima = variante.filter(function (v) { return v.available; })[0] || variante[0] || {};
    var pret = p.price_varies ? '<span class="ce-pereche__dela">de la</span> ' + esc(bani(p.price_min)) : esc(bani(p.price));
    var img = imagineUrl(p.featured_image, 160);
    var url = p.url || (RAD + 'products/' + p.handle);
    var h = '<div class="ce-pereche" data-ce-card data-produs="' + esc(p.id) + '">' +
      '<a class="ce-pereche__foto" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img class="ce-card__img" src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</a>' +
      '<div class="ce-pereche__text"><a class="ce-card__nume" href="' + esc(url) + '">' + esc(p.title) + '</a><span class="ce-pereche__pret">' + pret + '</span></div>';
    if (mod === 'pagina') {
      h += '<a class="ce-pereche__plus" href="' + esc(url) + '" aria-label="Alege opțiunile pentru ' + esc(p.title) + '"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg></a>';
    } else {
      h += '<button type="button" class="ce-pereche__plus" data-ce-plus data-mod="' + mod + '" data-varianta="' + esc(prima.id) + '" aria-label="Adaugă ' + esc(p.title) + ' în coș"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg></button>';
      if (mod === 'marime') {
        var date = {
          titlu: p.title,
          imagine: imagineUrl(p.featured_image, 160),
          variante: variante.map(function (v) { return { id: v.id, titlu: v.title, pret: bani(v.price), disponibil: v.available }; }),
        };
        h += '<script type="application/json" data-ce-variante>' + JSON.stringify(date).replace(/</g, '\\u003c') + '</script>';
      }
    }
    return h + '</div>';
  }
  function recomandari(intentie, limita) {
    return json(RAD + 'recommendations/products.json?product_id=' + encodeURIComponent(produsId) + '&limit=' + limita + '&intent=' + intentie)
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
  }
  function incarcaPerechi() {
    var el = cutie.querySelector('[data-ce-perechi]');
    if (!el) return;
    var lista = el.querySelector('[data-ce-perechi-lista]');
    var inCos = {};
    ((cos && cos.items) || []).forEach(function (it) { inCos[it.product_id] = true; });
    var bune = function (arr) {
      return arr.filter(function (p) { return p && p.available && String(p.id) !== String(produsId) && !inCos[p.id]; });
    };
    recomandari('complementary', 6).then(function (comp) {
      var ales = bune(comp);
      if (ales.length >= 3) return ales;
      return recomandari('related', 10).then(function (rel) {
        var vazute = {};
        ales.forEach(function (p) { vazute[p.id] = true; });
        return ales.concat(bune(rel).filter(function (p) { return !vazute[p.id]; }));
      });
    }).then(function (produse) {
      produse = produse.slice(0, 3);
      if (produse.length < 2) { el.hidden = true; return; }
      lista.innerHTML = produse.map(rand).join('');
      el.hidden = false;
    });
  }

  // ---------- scurtăturile ----------
  var TINTE = [
    { nume: 'Ingrediente', re: /^ingrediente\b/i, icoana: '<path d="M17 3c-6 0-11 3.6-11 10 0 1.4.3 2.7.9 3.8L4 19.6 5.4 21l2.8-2.8c1.1.6 2.4.8 3.8.8 6.4 0 9-6 9-13V3h-4zm-5 14c-.8 0-1.6-.1-2.3-.4l5-5-1.4-1.4-5 5c-.2-.7-.3-1.4-.3-2.2 0-4.7 3.7-7.5 8.6-8H19v.9C19 12.7 16.6 17 12 17z" fill="currentColor"/>' },
    { nume: 'Alergeni', re: /^(alergeni|con[țţt]ine)\b/i, icoana: '<path d="M12 2 1.6 20h20.8zm0 4.2L18.3 18H5.7zM11 10v4.5h2V10zm0 5.5v2h2v-2z" fill="currentColor"/>' },
    { nume: 'Valori nutriționale', re: /^(valori nutri|declara[țţt]ie nutri)/i, tab: /nutri/i, icoana: '<path d="M4 20h16v2H4v-2zM5 10h3v8H5v-8zm5.5-6h3v14h-3V4zM16 13h3v5h-3v-5z" fill="currentColor"/>' },
  ];
  // conținuturile în care se caută: descrierea Chefs (ce-descriere) sau taburile temei
  function continuturiTaburi() { return Array.prototype.slice.call(document.querySelectorAll('[data-ce-desc-panou],[data-t4s-tab-content]')); }
  function ascuns(el, panaLa) {
    for (var x = el; x && x !== panaLa; x = x.parentElement) {
      if (x.style && x.style.display === 'none') return true;
      // grupele descrierii Chefs sunt ascunse doar până se apasă butonul lor
      if (x.hidden && !x.hasAttribute('data-ce-desc-grupa')) return true;
    }
    return false;
  }
  function gasesteInTab(re) {
    var taburi = continuturiTaburi();
    for (var i = 0; i < taburi.length; i++) {
      var c = taburi[i];
      var el = Array.prototype.slice.call(c.querySelectorAll('h1,h2,h3,h4,h5,h6,strong,b,th,dt')).filter(function (e) {
        return re.test((e.textContent || '').replace(/\s+/g, ' ').trim()) && !ascuns(e, c);
      })[0];
      if (el) return { tab: c, el: el.closest('p,li,tr,dt,h1,h2,h3,h4,h5,h6') || el };
    }
    return null;
  }
  function gasesteTab(re) {
    var panouri = Array.prototype.slice.call(document.querySelectorAll('[data-ce-desc-panou][data-titlu]'));
    for (var k = 0; k < panouri.length; k++) {
      if (re.test(panouri[k].getAttribute('data-titlu')) && panouri[k].textContent.trim()) return { tab: panouri[k], el: panouri[k] };
    }
    var linkuri = Array.prototype.slice.call(document.querySelectorAll('a[data-t4s-tab-item][href^="#"]'));
    for (var i = 0; i < linkuri.length; i++) {
      if (!re.test(linkuri[i].textContent.trim())) continue;
      var c = document.getElementById(linkuri[i].getAttribute('href').slice(1));
      if (c && c.textContent.trim()) return { tab: c, el: c };
    }
    return null;
  }
  // tabul temei: linkurile de sus și conținuturile sunt în aceeași ordine (descrierea are alt id decât linkul ei)
  function deschideTab(c) {
    if (!c) return;
    var tabs = c.closest('[data-t4s-tabs]');
    var invelis = c.closest('[data-t4s-tab-wrapper]');
    if (!tabs || !invelis) return;
    if (invelis.classList.contains('t4s-active') && c.getClientRects().length) return;
    var sus = Array.prototype.slice.call(tabs.querySelectorAll('[data-t4s-tab-ul] a[data-t4s-tab-item]'));
    var link = c.id ? sus.filter(function (a) { return a.getAttribute('href') === '#' + c.id; })[0] : null;
    if (!link) link = sus[Array.prototype.indexOf.call(tabs.querySelectorAll('[data-t4s-tab-wrapper]'), invelis)];
    if (link && link.getClientRects().length) { link.click(); return; }
    var titlu = invelis.querySelector('.t4s-tab__title');
    if (titlu && titlu.getClientRects().length) titlu.click();
  }
  function du(tinta) {
    if (!(window.ceDescriere && window.ceDescriere.arata(tinta.el))) deschideTab(tinta.tab);
    setTimeout(function () {
      var sus = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ce-sus'), 10) || 0;
      var y = tinta.el.getBoundingClientRect().top + window.pageYOffset - sus - 24;
      window.scrollTo({ top: Math.max(0, y), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      tinta.el.classList.remove('ce-evidentiat');
      void tinta.el.offsetWidth;
      tinta.el.classList.add('ce-evidentiat');
      setTimeout(function () { tinta.el.classList.remove('ce-evidentiat'); }, 2000);
    }, 120);
  }
  function pregatesteScurtaturi() {
    var nav = cutie.querySelector('[data-ce-scurt]');
    if (!nav) return;
    var gasite = [];
    TINTE.forEach(function (t) {
      var x = gasesteInTab(t.re) || (t.tab ? gasesteTab(t.tab) : null);
      if (x) gasite.push({ nume: t.nume, tinta: x, icoana: t.icoana });
    });
    if (!gasite.length) return;
    nav.innerHTML = gasite.map(function (g, i) { return '<button type="button" data-ce-la="' + i + '"><svg viewBox="0 0 24 24" aria-hidden="true">' + g.icoana + '</svg>' + esc(g.nume) + '</button>'; }).join('');
    nav.hidden = false;
    // imediat sub „Adaugă în coș”, pe un singur rând
    var butoaneForm = document.querySelector('.t4s-product__info-container .t4s-product-form__buttons');
    if (butoaneForm && butoaneForm.parentNode) {
      butoaneForm.parentNode.insertBefore(nav, butoaneForm.nextSibling);
      nav.classList.add('is-sub-cos');
    }
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ce-la]');
      if (b) du(gasite[Number(b.getAttribute('data-ce-la'))].tinta);
    });
  }

  // ---------- coșul s-a schimbat (orice parte a paginii) ----------
  var temporizare = null;
  function cosSchimbat() {
    clearTimeout(temporizare);
    temporizare = setTimeout(function () { incarcaCos().then(deseneazaCadou); }, 250);
  }
  function urmaresteCosul() {
    if (!('PerformanceObserver' in window)) return;
    try {
      new PerformanceObserver(function (lista) {
        lista.getEntries().forEach(function (e) {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(e.name)) cosSchimbat();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (err) { /* browser vechi: bara rămâne cu valoarea de la încărcare */ }
    window.addEventListener('pageshow', function (e) { if (e.persisted) cosSchimbat(); });
  }

  function porneste() {
    cutie = document.querySelector('[data-ce-produs]');
    if (!cutie) return;
    produsId = cutie.getAttribute('data-produs');
    formatBani = cutie.getAttribute('data-ce-format-bani') || null;
    livrare.el = cutie.querySelector('[data-ce-livrare]');
    if (livrare.el) incarcaLivrare();
    Promise.all([incarcaCos(), cutie.querySelector('[data-ce-cadou]') ? incarcaCadou() : null]).then(function () {
      deseneazaCadou();
      incarcaPerechi();
    });
    pregatesteScurtaturi();
    urmaresteCosul();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste); else porneste();
})();
